import _ from 'lodash'
import constants from 'scoreboard/components/constants'

const columnsAggregatedableBySqlMap = _.memoize(function() {
	return _.keyBy(constants.initiativeFieldsAggregatableBySql)
})
const fieldsAggregatedableBySqlMap = columnsAggregatedableBySqlMap

function scoringColorTypeForColumnType(columnType) {
	return _.get(constants.initiativeReportColumnTypes[columnType],'scoringColorType', null)
}

function isColumnTypeUsingPeriodRangedForRepeatBy(columnType) {
	return _.get(constants.initiativeReportColumnTypes[columnType],'changesOverTime', false)
}

export { fieldsAggregatedableBySqlMap, scoringColorTypeForColumnType, isColumnTypeUsingPeriodRangedForRepeatBy }